import { Card, Button } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { useStake } from "@/src/hooks/useStake";
import { useAccount } from "wagmi";
import { toast } from "react-hot-toast";
import { useDaoVotes } from "@/src/hooks/useVotes";
import { useEffect, useState } from "react";

export const DaoButtons = () => {
  const { yes, no, vote_enabled, deadline } = useDaoVotes();
  const { uncharged,charged } = useBalances();
  const {  onExecuteVote, onCancelDaoVote } = useStake();
  const { isConnected } = useAccount();
  const [isValid, setValid] = useState(false);

  const onIncrease = async () => {
    if (!isConnected) return;

    toast.promise(onExecuteVote(), {
      loading: "Transaction is in progress",
      success: "Successfully executed proposed change",
      error: (data) => data,
    });
  }
  const onCancel = async () => {
    if (!isConnected) return;

    toast.promise(onCancelDaoVote(), {
      loading: "Transaction is in progress",
      success: "Successfully canceled proposal",
      error: (data) => data,
    });
  }
  const validate = () => {
    if (parseInt(no) >= parseInt(yes)){
      return false;
    }
    if (vote_enabled===false){
      return false;
    }
    if ((parseInt(uncharged)+parseInt(charged)) === 0){
      return false;
    }
    if (Date.now()/1000 < (deadline)){
      return false;
    }else{return true;}
  };

  useEffect(() => {
    const isValid = validate();
    setValid(isValid);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vote_enabled, uncharged, deadline, yes, no]);

  return (
    <Card>
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Proposal Actions</h3>
        <div className="space-y-3">
          <Button onClick={onIncrease} disabled={!isValid} className="bg-primary/15 text-primary border border-primary/30 hover:bg-primary/25 hover:shadow-none w-full">
            Execute Proposal
          </Button>
          <Button onClick={onCancel} disabled={!isValid} className="bg-destructive/15 text-destructive border border-destructive/30 hover:bg-destructive/25 hover:shadow-none w-full">
            Cancel Proposal
          </Button>
        </div>
      </div>
    </Card>

  );
};
